import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ComponentService } from '../../../../services/component.service';
import { Subscription } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';

@Component({
	selector: 'app-client-selected-updates',
	templateUrl: './client-selected-updates.component.html',
	styleUrls: ['./client-selected-updates.component.scss']
})
export class ClientSelectedUpdatesComponent implements OnInit, OnDestroy {
	@ViewChild('snippet', { static: false }) snippet: ElementRef;
	@ViewChild('countdownPreviewSelect', { static: false }) countdownPreviewSelect: ElementRef;
	@ViewChild('personalizedImagePreview', { static: true }) personalizedImagePreview: ElementRef;
	@Output() output = new EventEmitter<any>();
	@Input() editPage;
	@Input() refresh;
	componentData: any;
	componentDataSubscription: Subscription;
	previewTagValue;
	previewTagList;
	segmentedCSVList = false;
	dynamicStaticList = [26, 36, 39, 41, 44];

	constructor(private component: ComponentService, private http: HttpClient) {}

	ngOnInit() {
		this.componentDataSubscription = this.component.componentData
			.pipe(
				filter((data) => data !== null),
				distinctUntilChanged()
			)
			.subscribe((result) => {
				this.componentData = result;
				if (this.componentData.config.type == 32) {
					this.getTagList();
				}
			});
	}

	ngOnDestroy() {
		this.componentDataSubscription.unsubscribe();
	}

	toggleDynamic() {
		this.sendSelectedUpdate(true, this.toggleDynamic.name);
	}

	updateSegmentedPreview(event, dropdown = true) {
		this.sendSelectedUpdate(
			{
				event,
				dropdown,
				previewTagList: this.previewTagList
			},
			this.updateSegmentedPreview.name
		);
	}

	getTagList() {
		if (this.componentData.config.use_external_csv && this.componentData.config.csv_list) {
			this.segmentedCSVList = true;
			this.getCSVData(this.componentData.config.csv_list);
		} else {
			this.previewTagList = this.componentData.config.items.filter((item) => item.tag !== '');
			this.segmentedCSVList = false;
		}
	}

	getCSVData(url) {
		let csvData = [];
		this.http.get(url, { responseType: 'text' }).subscribe((data) => {
			let csvRows = data.split('\r\n');
			csvRows.forEach((item) => {
				if (item.length) {
					const data = item.split(',');
					csvData.push({
						tag: data[0],
						image: data[1],
						link: data[2] ? data[2] : ''
					});
				}
			});
			this.previewTagList = csvData.slice(1);
		});
	}

	countdownPreview(event) {
		this.countdownPreviewSelect.nativeElement.value = 'default';
		this.sendSelectedUpdate(event, this.countdownPreview.name);
	}

	updatePersonalizedImageTag(event) {
		this.sendSelectedUpdate(event, this.updatePersonalizedImageTag.name);
	}

	updateProgressImageTag(event) {
		this.sendSelectedUpdate(event, this.updateProgressImageTag.name);
	}

	showPreviewMultiTagModal() {
		this.sendSelectedUpdate(true, this.showPreviewMultiTagModal.name);
	}

	sendSelectedUpdate(params, method) {
		this.output.emit({ method, data: params });
	}
}
